import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useBreadcrumbs } from '../context/BreadcrumbContext';
import './Breadcrumbs.css';

const segmentLabels = {
  accounts: 'Accounts',
  contacts: 'Contacts',
  opportunities: 'Opportunities',
  products: 'Products',
  quotes: 'Quotes',
  orders: 'Orders',
  tasks: 'Action Items',
  activities: 'Activities',
  dashboard: 'Dashboard',
  settings: 'Settings',
  users: 'Users',

  'action-items': 'Action Items',
  'rep-firms': 'Rep Firms',
  'quote-template-editor': 'Quote Template Editor',
  'module-management': 'Module Management',
  permissions: 'Permissions',
  new: 'New',
};

function Breadcrumbs() {
  const location = useLocation();
  const { customBreadcrumbs } = useBreadcrumbs();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Don't render breadcrumbs on the dashboard (home) page
  if (pathSegments.length === 0) {
    return null;
  }

  // Use custom breadcrumbs from context if available, otherwise auto-generate
  const breadcrumbs = customBreadcrumbs
    ? customBreadcrumbs.map((item, index) => ({
        path: item.path || null,
        label: item.label,
        isLast: index === customBreadcrumbs.length - 1,
      }))
    : pathSegments.map((segment, index) => {
        const path = '/' + pathSegments.slice(0, index + 1).join('/');
        const isLast = index === pathSegments.length - 1;
        const label = segmentLabels[segment] || segment;

        return { path, label, isLast };
      });

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumbs-list">
        <li className="breadcrumb-item">
          <Link to="/" className="breadcrumb-link breadcrumb-home">
            <Home size={14} />
            <span>Home</span>
          </Link>
        </li>
        {breadcrumbs.map(({ path, label, isLast }, index) => (
          <li key={path || `breadcrumb-${index}`} className="breadcrumb-item">
            <ChevronRight size={12} className="breadcrumb-separator" />
            {isLast || !path ? (
              <span className="breadcrumb-current">{label}</span>
            ) : (
              <Link to={path} className="breadcrumb-link">
                {label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
